import { render, staticRenderFns } from "./OsMakeList.vue?vue&type=template&id=07c9e3a5"
import script from "./OsMakeList.vue?vue&type=script&lang=js"
export * from "./OsMakeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports